import React from 'react';
import type { AiFunnelData } from '../../types/dashboard';

interface Props {
  data: AiFunnelData | null;
}

const BAR_COLORS = ['#6366f1', '#818cf8', '#a5b4fc', '#c7d2fe'];

export default function AiFunnelChart({ data }: Props) {
  if (!data || !data.steps || data.steps.length === 0) {
    return <Placeholder text="No AI prefill funnel data available" />;
  }

  const maxCount = Math.max(...data.steps.map((s) => s.count), 1);

  return (
    <div style={sectionStyle}>
      <h3 style={headingStyle}>AI Prefill Funnel</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {data.steps.map((step, i) => {
          const widthPct = Math.max((step.count / maxCount) * 100, 8);
          const conversionPct =
            i > 0 && data.steps[i - 1].count > 0
              ? Math.round((step.count / data.steps[i - 1].count) * 100)
              : null;
          return (
            <div key={step.name} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 140, flexShrink: 0, textAlign: 'right' }}>
                <span style={{ fontSize: 12, color: '#374151', fontWeight: 500 }}>{step.name}</span>
              </div>
              <div style={{ flex: 1, position: 'relative' }}>
                <div
                  style={{
                    height: 36,
                    width: `${widthPct}%`,
                    backgroundColor: BAR_COLORS[i] || BAR_COLORS[0],
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 12,
                    transition: 'width 0.3s ease',
                  }}
                >
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{step.count}</span>
                </div>
              </div>
              <div style={{ width: 50, flexShrink: 0 }}>
                {conversionPct != null && (
                  <span style={{ fontSize: 11, color: '#9ca3af' }}>{conversionPct}%</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Placeholder({ text }: { text: string }) {
  return (
    <div style={{ ...sectionStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 160, color: '#9ca3af' }}>
      {text}
    </div>
  );
}

const sectionStyle: React.CSSProperties = {
  backgroundColor: '#fff',
  borderRadius: 12,
  padding: 24,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
};

const headingStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  color: '#111827',
  margin: '0 0 16px 0',
};
